<template>
    <div class="horizontal-dots-loader">
        <div class="sr-only">{{ $t("loading") }}</div>
        <div class="horizontal-dots-loader__content">
            <span class="horizontal-dots-loader__bubble"></span>
            <span class="horizontal-dots-loader__bubble"></span>
            <span class="horizontal-dots-loader__bubble"></span>
            <span class="horizontal-dots-loader__bubble"></span>
            <span class="horizontal-dots-loader__bubble"></span>
        </div>
    </div>
</template>

<script>

export default {
    name: "HorizontalDotsLoader",
};
</script>

